module.exports = __webpack_public_path__ + "img/resume.83e2c142.svg";